import { lazy } from 'react';

export const MainPageFrame = lazy(() => import('./MainPageFrame'));
